import React, { useContext } from 'react';
import Slider from '@material-ui/core/Slider';

// JSON & Styles
import { makeStyles } from '@material-ui/core/styles';
import { SearchContext } from 'contexts/SearchContext';
const TrailLengthSlider = ({ setAdvancedOptions, advancedOptions, rangeVals, setRangeVals }) => {
  const { state, setState } = useContext(SearchContext);

  const useStyles = makeStyles((theme) => ({
    root: {
      width: '75%',
      margin: '0 auto',
      height: '20px',
      marginTop: '35px',
    },
  }));
  const classes = useStyles();

  const marks = [
    {
      value: 0,
      label: '0 mi',
    },
    {
      value: 20,
      label: '20+ mi',
    },
  ];

  const handleChange = (e, val) => {
    val && setState({ ...state, searchTerm: '' });
    setAdvancedOptions({ ...advancedOptions, ['Length']: val });

    setRangeVals(val);
  };

  const valuetext = (value) => {
    return `${value} mi`;
  };

  return (
    <Slider
      onChange={handleChange}
      //defaultValue={rangeVals}
      value={rangeVals}
      getAriaValueText={valuetext}
      aria-labelledby='Trail Length Slider'
      min={0}
      max={20}
      step={1}
      valueLabelDisplay='on'
      marks={marks}
      classes={{ root: classes.root }}
    />
  );
};

export default TrailLengthSlider;
